<template lang="pug">
  .color-bar-map-section.container
    .ui-color-3-bg
      .row.fixed-width-tweak-upper
        ProgressStep
    .row.xs-f-small.max-at-tweak.fixed-width-tweak-upper
      .xs-12.text-center.xs-p-5.sm-p-0
        .fixed-width-tweak-upper.pb-100m
          h1.title.xs-f-medium.sm-f-small.lg-f-large.max-at-tweak.sm-pt-30sm-pb-30 {{ title }}
          span.xs-hide {{ subTitle }}
      template(v-if="!locations || !locations.length")
        .map-and-locations-container.xs-12.fixed-width-tweak-upper.sm-mb-50
          .xs-12.sm-6.xs-mt-20.sm-mt-0.sm-pr-30.xs-p-5.xs-pt-0.sm-pb-0
            .location-search-form.xs-f-small.max-at-tweak
              .xs-12
                .ssc-line.mb-50m
                .ssc-line.mb-50m
                .ssc-line.mb-50m
                .ssc-line.mb-50m
            .xs-12.xs-p-5.xs-pl-0.xs-pr-0.sm-p-0.sm-mt-20
              p.mt-5.mb-10.xs-f-xsmall.max-at-tweak.ssc-line
              .ssc-card.ssc-wrapper.mb-100m(v-for="i in 3" :key="i")
                .nearby-location.text-left.mt-10
                  .top-wrap(style="display: flex;")
                    .location-description.pr-10.xs-12.md-8
                      .colorbar-name.mt-10.mb-10
                        .ssc-line
                      .ssc-line.mb-10
                      .ssc-line
                    .image-wrap.a-box-xs-4x3.xs-12.md-4.mb100m
                      .a-box-content
                        .image-box
                          .ssc-square(style="height: 100%;width: 100%;")
                  .bottom-wrap.pt-50m
                    p.brand-color-1.upper.xs-f-xxsmall.max-at-tweak.ssc-line
                    ul.visit-list.xs-f-xsmall.max-at-tweak
                      li
                        .ssc-line
                  .ctas.text-center.pt-100m
                    .ssc-line(style="height: 1.5em;")

          .xs-12.sm-6.sm-pl-30
            .map-container
              .ssc-square(style="min-height: 270px;")

      .map-and-locations-container.xs-12.fixed-width-tweak-upper.sm-mb-50(v-else)
        .xs-12.sm-6.xs-mt-20.sm-mt-0.sm-pr-30.xs-p-5.xs-pt-0.sm-pb-0
          .location-search-form.xs-f-small.max-at-tweak
            .first-line.mb-5
              p.xs-f-xxsmall.text-color-3 {{ inputTopText }}
              p.xs-f-xxsmall.text-color-3(v-if="loadingUserGeoLocation") Loading location...
              button.btn-link.underline.geo-location-cta.xs-f-xxsmall(
                v-else
                @click="getCurrentPosition"
              )
                MrIcon.mr-2(name="location" height="1.5em")
                span {{useLocationText}}
            form.search-input-container.mt-5.mb-5(name="GmapAutocomplete" @submit.prevent="setLocationBySubmit")
              GmapAutocomplete.search-input(
                ref="autocomplete"
                :value="autocompleteContent"
                @place_changed="onPlaceChanged"
                :options="{ componentRestrictions: { country: 'us' } }"
                :select-first-on-enter="true"
              )
              button.inner-button
                MrIcon(name="search" height="2em" @click="setLocationBySubmit")
            p.mt-5.mb-5.xs-f-xxsmall.text-color-3 {{ inputExampleText }}

          button.btn-link.underline.bold.mt-10.xs-hide(
            @click="onGoToDirectoryClicked"
            tabindex="0"
          ) {{ seeAllText }}

          .xs-12.xs-p-5.xs-pl-0.xs-pr-0.sm-p-0.sm-mt-20
            p.mt-5.mb-10.xs-f-xsmall.max-at-tweak(v-if="currentPlace")
              | Showing
              span.bold &nbsp;{{ nearbyLocations.length }}&nbsp;
              | locations near
              span.bold(v-html="currentPlace.formatted_address")

            NearbyLocation(
              v-for="location in nearbyLocations"
              :key="location.name"
              :location="location"
            )

            WaitlistForm(
              :new-version="true"
              v-if="!nearbyLocations.length && currentPlace"
            )

        .xs-12.sm-6.sm-pl-30
          .map-container(:class="{ sticky: nearbyLocations && nearbyLocations.length }")
            GmapMap.map(
              ref="map"
              :center="center"
              :zoom="zoom"
              :options="{ disableDefaultUI: true, zoomControl: true, fullscreenControl: true, minZoom: 3, maxZoom: 14 }"
              :style="mapDimensions"
            )

              GmapInfoWindow(
                v-if="selectedMarker"
                :opened="!!selectedMarker"
                :options="selectedMarker.options"
                :position="selectedMarker.position"
                @closeclick="selectedMarker = null;"
              )
                MarkerInfoWindow(:location="selectedMarker.location")

              GmapMarker.brand-color-1(
                :key="index"
                v-for="(marker, index) in markers"
                :position="marker.position"
                @click="() => onMarkerClicked(marker)"
                :icon="iconConfig"
                :title="marker.location.name"
              )

              GmapMarker(
                v-if="currentPlace"
                :position="currentPlace.position"
            )

    .container
      .xs-12.locations-directory-container
        LocationsDirectory(:locations="locations")
</template>

<script>
  import { components, helpers, getGoogleMapsAPI } from 'gmap-vue';
  const { googleMapsApiInitializer } = helpers;

  import WaitlistForm from '@components/HairColorBar/WaitlistForm';
  import { getActiveLocationsListForMapView } from '@services/vueColorbarSvc';
  import MrIcon from '@components/MrIcon';
  import ImgBox from '@components/imgBox';
  import { mapState, mapMutations, mapActions } from 'vuex';
  import SectionTitle from '@components/SectionTitle';
  import Breadcrumbs from '@components/Breadcrumbs';
  import MarkerInfoWindow from './MarkerInfoWindow';
  import NearbyLocation from './NearbyLocation';
  import LocationsDirectory from './LocationsDirectory';
  import ProgressStep from '../HairColorBarBooking/ProgressStep';


  import throttle from 'lodash.throttle';

  const KMS_TO_MILES_COEFFICIENT = 0.000621371 * 1000;

  const UNITED_STATES_CENTER = {
    lat: 39.8097343,
    lng: -98.5556199,
  };

  const DEFAULT_ZOOM_LEVEL = 3;

  const MAX_MARKERS_DISTANCE_FROM_CENTER_IN_MILES = 60;

  export default {
    name: 'ColorBarMapSection',

    components: {
      GmapMarker: components.Marker,
      GmapMap: components.MapLayer,
      GmapAutocomplete: components.Autocomplete,
      GmapInfoWindow: components.InfoWindow,
      MrIcon,
      ImgBox,
      Breadcrumbs,
      SectionTitle,
      MarkerInfoWindow,
      NearbyLocation,
      LocationsDirectory,
      WaitlistForm,
      ProgressStep,
    },

    props: {
      breadcrumbs: {
        type: Array,
        default: () => ([
          { title: 'Hair Color Bar', url: '/colorbar' },
          { title: 'Find a Hair Color Bar Near You' },
        ]),
      },
      title: {
        type: String,
        required: true,
      },
      subTitle: {
        type: String,
        default: ''
      },
      inputTopText: {
        type: String,
        required: true,
      },
      useLocationText: {
        type: String,
        required: true,
      },
      inputExampleText: {
        type: String,
        required: true,
      },
      seeAllText: {
        type: String,
        required: true,
      },
      nearbyLocationsMaxDistance: {
        type: Number,
        default: MAX_MARKERS_DISTANCE_FROM_CENTER_IN_MILES,
      }
    },

    data: () => ({
      autocompleteContent: '',
      locations: [],
      selectedMarker: null,
      center: UNITED_STATES_CENTER,
      zoom: DEFAULT_ZOOM_LEVEL,
      currentPlace: null,
      loadingUserGeoLocation: false,
    }),

    computed: {
      ...mapState('global', ['windowData']),
      ...mapState('customer', ['cdata']),
      gmapApi: getGoogleMapsAPI,

      isMobile() {
        return this.windowData.breakpoint === 'mobile';
      },

      iconConfig() {
        const width = 20;
        return {
          url: `https://d3ewrnwdcmri66.cloudfront.net/content/images/2022/2/l1cm1wy8-map-marker-2/map-marker-2.png`,
          scaledSize: {
            width,
            height: Math.round(width * 1.25),
          },
        };
      },

      mapDimensions() {
        if (!this.isMobile) {
          return {
            width: '100%',
            height: '350px',
          };
        }

        return {
          width: '100%',
          height: '270px'
        };
      },

      nearbyLocations() {
        if (!this.currentPlace) {
          return [];
        }

        const nearbyLocations = [];

        this.locations.forEach(location => {
          const distanceInMeters = this.gmapApi.maps.geometry.spherical.computeDistanceBetween(
            this.currentPlace.position,
            location.position
          );

          const distanceInMiles = (distanceInMeters / 1000) * KMS_TO_MILES_COEFFICIENT;
          if (distanceInMiles > this.nearbyLocationsMaxDistance) {
            return;
          }

          nearbyLocations.push({
            ...location,
            distance: distanceInMiles,
          });
        });

        return nearbyLocations.sort(({ distance: d1 }, { distance: d2 }) => d1 - d2);
      },

      markers() {
        return this.locations.map(location => {
          return {
            location,
            position: location.position,
            options: {
              maxWidth: 384,
              pixelOffset: {
                width: 0,
                height: -20,
              },
            },
          };
        });
      },
    },

    watch: {
      mapDimensions() {
        this.resizeMap();
      },
    },

    destroyed() {
      this.resetBreadcrumbs();
    },

    async mounted() {
      let config = this.$root.MRConfig || window?.MR?.config || {};
      googleMapsApiInitializer({
        key: config.googleAutocomplete,
        libraries: 'places,geometry',
        v: '2',
      }, false);

      await this.$gmapApiPromiseLazy();

      this.setBreadcrumbs(this.breadcrumbs);
      this.getLocations();

      this.getLocationFromCustomerData();

      this.setProgressStep('locationStep');
    },

    methods: {
      ...mapMutations('global', [
        'setBreadcrumbs',
        'resetBreadcrumbs',
      ]),

      ...mapActions(['notifyError']),

      ...mapMutations('hairColorBarBooking', [
        'setProgressStep'
      ]),

      onSearchClicked() {
        const keyboardEvent = new KeyboardEvent('keydown', {
          code: 'Enter',
          key: 'Enter',
          charCode: 13,
          keyCode: 13,
          view: window,
          bubbles: true
        });
        this.$refs.autocomplete.$el.dispatchEvent(keyboardEvent);
      },

      setLocationBySubmit() {
        const el = this.$refs.autocomplete.$refs.input;
        const ev = new Event('keydown');

        ev.which = 13;
        ev.keyCode = 13;

        return el.dispatchEvent(ev);
      },

      onGoToDirectoryClicked() {
        this.trackEvent('See Directory CTA Clicked');
        this.scrollTo('.colorbar-locations-directory');
      },

      resizeMap: throttle(function () {
        this.gmapApi?.maps?.event?.trigger(this.$refs.map, 'resize');
      }, 300),

      getLocations() {
        getActiveLocationsListForMapView()
          .then(({ data }) => {
            this.locations = data;
          })
          .catch((error) => {
            this.notifyError(null, error);
          });
      },

      onPlaceChanged(place) {
        this.trackEvent('Search Place Input Changed', { place });
        this.setCurrentPlace(place);
      },

      setCurrentPlace(place) {
        if (!place) {
          return;
        }

        this.selectedMarker = null;

        if (place.geometry) {
          place.position = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
        }

        this.currentPlace = place;

        if (place.formatted_address) {
          this.autocompleteContent = place.formatted_address;
        }

        this.$nextTick(() => {
          if (this.nearbyLocations && this.nearbyLocations.length) {
            const bounds = new this.gmapApi.maps.LatLngBounds();
            this.nearbyLocations.forEach(({ position }) => {
              bounds.extend(position);
            });
            bounds.extend(this.currentPlace.position);
            this.$refs.map.fitBounds(bounds);
          } else {
            this.center = UNITED_STATES_CENTER;
            this.zoom = null; // should reset the zoom before so the map is re rendered later
            this.$nextTick(() => {
              this.zoom = DEFAULT_ZOOM_LEVEL;
              const mapRef = this.$refs.map;
              if (mapRef?.panTo) {
                mapRef.panTo(this.center);
              }
            });
          }
        });
      },

      onMarkerClicked(marker) {
        this.trackEvent(`Map Marked Clicked`, { marker });
        this.selectedMarker = marker;
      },

      getLocationFromCustomerData() {
        if (!this.gmapApi) {
          return;
        }

        if (!this.cdata) {
          return;
        }

        const { locationContext, address } = this.cdata;

        let filter;

        if (address && address.city && address.street_1) {
          const { city, country, post_code, street_1, street_2 } = address;
          filter = {
            address: `${street_1} ${street_2}, ${city} ${country} ${post_code}`,
          };
        } else if (locationContext) {
          const { latitude, longitude } = locationContext;
          filter = {
            location: {
              lat: latitude,
              lng: longitude,
            },
          };
        }

        if (!filter) {
          return;
        }

        const geocoder = new this.gmapApi.maps.Geocoder();
        geocoder
          .geocode(filter)
          .then(({ results }) => {
            const [location] = results;
            if (location) {
              this.setCurrentPlace(location);
            }
          }).catch((err) => {
            this.notifyError({ err, silent: true });
          });
      },

      getCurrentPosition() {
        if (!this.gmapApi) {
          return;
        }

        this.trackEvent(`Use My Location CTA Clicked`);
        this.loadingUserGeoLocation = true;
        navigator.geolocation.getCurrentPosition((currentPosition) => {
          const { coords: { latitude, longitude } } = currentPosition;
          this.loadingUserGeoLocation = false;
          this.autocompleteContent = '';

          const position = {
            lat: latitude,
            lng: longitude,
          };

          const geocoder = new this.gmapApi.maps.Geocoder();
          geocoder
            .geocode({ location: position })
            .then((response) => {
              const location = {
                ...response.results[0],
                position,
              };
              this.setCurrentPlace(location);
            }).catch(() => {
              this.setCurrentPlace({
                position,
              });
            });

        }, (error) => {
          this.loadingUserGeoLocation = false;
          if (error.code === 1) {
            this.notifyError('You must share your location first.');
          }
        });
      },
    },
  };
</script>

<style lang="stylus">
.color-bar-map-section

  .locations-directory-container
    background-color ui-color-2


  .title
    text-align center
    text-transform none

  .first-line
    display flex
    flex-direction row
    justify-content space-between

  .search-input
    width 100%
    input
      width 100%

  .map-and-locations-container
    display flex
    flex-direction row

  .map-container
    &.sticky
      position sticky
      top 1em

  .search-input-container
    display flex
    flex-direction row
    position relative
    .search-input
      input
        margin 0 !important
        flex 1
        height 44px
        font-size 16px
        padding 10px
        width 100%
        margin 0.55em 0
        border-radius 4px
        padding-right 40px
    .inner-button
      cursor pointer
      background-color brand-color-1
      color ui-color-1
      position absolute
      display flex
      justify-content center
      align-items center
      right 0
      border-radius 4px
      height 44px
      width 44px
      max-width 44px
      max-height 44px
      overflow hidden
      vertical-align middle
      text-decoration none
      line-height 1.3em !important
      white-space nowrap

@media mq-mobile
  .color-bar-map-section

    .map-container
      &.sticky
        position inherit
        top inherit

    .title
      font-weight bold
      text-transform uppercase
      text-align: left

    .map-and-locations-container
      flex-direction column-reverse
</style>